"use client";

import { Component, useEffect, type ReactNode } from "react";
import { clearAuthToken } from "@/lib/auth-client";
import { isAuthenticationError } from "@/lib/utils/convex-error-handler";

import { redirectToFoodCreatorSignIn } from "@/lib/food-creator-navigation";

function ExpiredSession() {
  useEffect(() => {
    clearAuthToken();
    redirectToFoodCreatorSignIn();
  }, []);

  return <p role="status" className="p-6">Redirecting to sign in...</p>;
}

/** Catch revoked-session queries even when they originate in the auth provider. */
export class FoodCreatorSessionBoundary extends Component<
  { children: ReactNode },
  { error: Error | null }
> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (error) {
      // Do not hide permission failures, network failures or application defects.
      // Avoid a redirect loop if a sign-in page itself fails authentication.
      if (isAuthenticationError(error) && window.location.pathname !== "/food-creator/sign-in") {
        return <ExpiredSession />;
      }
      throw error;
    }
    return this.props.children;
  }
}
